(function () {
    'use strict';

    $('.deletarRegistro').on('click', function (event) {
        const atributoThis = this;
        swal({
            title       : 'Você tem certeza?',
            text        : 'Depois de excluido, não poderar mais ser recuperado',
            icon        : 'warning',
            buttons     : true,
            dangerMode  : true,
        })
        .then((deletar) => {
            if (deletar){
                window.location.replace(atributoThis.getAttribute('href'))
            }
        });

        event.preventDefault()
    });
})();
